import React from 'react';
import { Link } from 'react-router-dom';
import { pathJoin } from '../../../services/api';
import { Add, Delete, Edit } from '../../shared/actions/actionButtons';
import { QueryGrid } from '../../shared/grid/queryGrid/queryGrid';
import { Telephone } from '../../shared/links/telephone';
import { SystemStatus } from './systemStatus';

import styles from './systemList.module.css';
import { SYSTEM } from '../../../permissions';

export const SystemList = (props) => {
    return <QueryGrid
        queryParamPrefix=''
        singleResourceName='System'
        pluralResourceName='Systems'
        nameFunction={r => r.name}
        restEndpoint='/systemAccess'
        listUrl='/systemAccess'
        actions={[Add, Edit, Delete]}
        readPermissions={[SYSTEM.READ]}
        writePermissions={[SYSTEM.WRITE]}
        columns={{
            status: {
                label: 'Status',
                size: '75px',
                formatFunction: r => <SystemStatus status={r.status} />,
            },
            name: {
                label: 'Name',
                passOnClick: true,
                formatFunction: r => <Link to={pathJoin('/systemAccess', r.id)}>{r.name}</Link>,
            },
            authorizedUserCount: {
                label: 'Authorized Users',
            },
            helpITPhone: {
                label: 'IT Helpdesk Phone',
                formatFunction: r => <Telephone number={r.helpITPhone} extension={r.helpITPhoneExtension} />,
            },
        }}
        {...props}
    />
}